import styled, { css } from 'styled-components/macro';

import { colors } from '../../styles/vars';

const dismissButton = css`
  color: ${colors['warm-grey-two']};
  background-color: ${colors['white-four']};
  transition: color 0.25s;

  &:hover {
    color: rgba(128, 128, 128, 0.7);
  }
`;

const confirmButton = css`
  color: #fff;
  background-color: ${colors['dusty-orange']};
  transition: color 0.25s;

  &:hover {
    color: rgba(255, 255, 255, 0.7);
  }
`;

const ModalButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 115px;
  height: 35px;
  border-radius: 2px;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;

  ${props => props.type === 'dismiss' && dismissButton}
  ${props => props.type === 'confirm' && confirmButton}
`;

export default ModalButton;
